(function () {
  //force refresh on back button

  if (
    !!window.performance &&
    window.performance.getEntriesByType("navigation")[0].type === "back_forward"
  ) {
    window.location.reload();
  }

  var overlay = $("#overlay");
  var menuOffCanvas = $("#menu-off-canvas");

  var controls = {
    menuOffCanvasTrigger: $("[data-menu-offcanvas-trigger]"),
    drawerOffCanvasTrigger: $("[data-menu-offcanvas-drawer-trigger]"),
  };

  var modalAccFunction = function (e) {
    var isTabPressed = e.key === "Tab" || e.keyCode === 9;

    if (!isTabPressed) {
      return;
    }

    if (e.shiftKey) {
      if (document.activeElement === e.data.firstFocusableElement[0]) {
        setTimeout(function () {
          e.data.lastFocusableElement.focus();
        }, 300);

        e.preventDefault();
      }
    } else {
      if (document.activeElement === e.data.lastFocusableElement[0]) {
        setTimeout(function () {
          e.data.firstFocusableElement.focus();
        }, 300);

        e.preventDefault();
      }
    }
  };

  window.theme.functions = {
    // alert function that displays message and then removes the alert after timeout period
    triggerAlert: function (message, alertType) {
      $(".js-alert").html(message);
      $(".js-alert").toggleClass(alertType + "-alert");
      $(".js-alert").toggleClass("active");

      setTimeout(function () {
        $(".js-alert").toggleClass(alertType + "-alert");
        $(".js-alert").toggleClass("active");
      }, 5000);

      return false;
    },
    modalAccessibility: function (target) {
      let firstFocusableElement = $(
        "#" + target + " .off-canvas-drawer-inner-close"
      );

      let lastFocusableElement = $("#" + target + " .final-off-canvas-item");

      setTimeout(function () {
        $(firstFocusableElement).focus();
      }, 100);

      $(document).on(
        "keydown",
        {
          firstFocusableElement: firstFocusableElement,
          lastFocusableElement: lastFocusableElement,
        },
        modalAccFunction
      );
    },
    removeModalAccessibility: function (target) {
      $(document).off("keydown", modalAccFunction);
    },
  };

  controls.menuOffCanvasTrigger.on("click", function (event) {
    event.preventDefault();

    if (menuOffCanvas.hasClass("left-0")) {
      menuOffCanvas
        .removeClass("visible left-0")
        .addClass("invisible -left-full md:-right-1/3");
      overlay.removeClass("visible opacity-80").addClass("invisible opacity-0");
    } else {
      menuOffCanvas
        .removeClass("invisible -left-full md:-right-1/3")
        .addClass("visible left-0");
      overlay.removeClass("invisible opacity-0").addClass("visible opacity-80");
    }

    return false;
  });

  var scrollPostion = 0;

  $(window).scroll(function () {
    scrollPostion = $(window).scrollTop();

    if ($(".js-site-header").length > 0) {
      if (
        scrollPostion > 110 &&
        !$(".site-header-logo-full").hasClass("hidden")
      ) {
        $(".js-site-header").css("top", "0");
        $(".site-header-inner").addClass("has-icon");
        $(".site-header-logo-full").addClass("hidden");
        $(".site-header-logo-icon").addClass("block");
        $(".site-header-logo-icon").removeClass("hidden");
      }

      if (
        scrollPostion < 110 &&
        $(".site-header-logo-icon").hasClass("block")
      ) {
        $(".site-header-default").css("top", "0");
        $(".site-header-inner").removeClass("has-icon");
        $(".site-header-logo-icon").removeClass("block");
        $(".site-header-logo-full").removeClass("hidden");
      }
    }
  });

  $("[data-target]").on("click", function () {
    var target = $(this).data("target");

    $(target).toggleClass("hidden");
  });

  $("[data-toggle-drawer]").on("click", function () {
    var target = $(this).data("toggleDrawer");

    $(target).toggleClass("invisible");

    $(target).find(".js-edit-panel-inner").toggleClass("-right-full");
  });

  controls.drawerOffCanvasTrigger.on("click", function (event) {
    event.preventDefault();

    var drawerOverlay = $(this).data("overlay");
    var drawer = $(this).data("drawer");

    if ($(drawer).hasClass("right-0")) {
      window.theme.functions.removeModalAccessibility($(drawer).attr("id"));

      $(drawer).removeClass("right-0").addClass("-right-full");
      $(drawerOverlay)
        .removeClass("visible opacity-80")
        .addClass("invisible opacity-0");
    } else {
      window.theme.functions.modalAccessibility($(drawer).attr("id"));

      $(drawer).removeClass("-right-full").addClass("right-0");
      $(drawerOverlay)
        .removeClass("invisible opacity-0")
        .addClass("visible opacity-80");
    }

    //pause any audio files that may be playing when off-canvas is closed
    $("audio").each(function () {
      $(this)[0].pause();
    });

    $(".audio-pause-icon").each(function () {
      $(this).removeClass("active");
    });

    return false;
  });
})();
